import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["color"];
import React from 'react';
function Expand(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#788590' : _ref$color,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 6v12H6V6h12zM8 11v5h5l-5-5zm8-3h-5l5 5V8z",
    fill: color
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: color,
    strokeWidth: "2",
    x: "4",
    y: "4",
    width: "16",
    height: "16",
    rx: "2"
  })));
}
export default Expand;